export default "__VITE_ASSET__Sfg2N5ST60QWT3Jm56o_yg__"